exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ZGsu9NVWeyQEtYwQvp0Ca .campaign-status{color:dycolor-internal(!color,@theme-white);background:dycolor-internal(!background,@primary)}.ZGsu9NVWeyQEtYwQvp0Ca .campaign-issue{background:dycolor-internal(!issue-background,@theme-error);color:dycolor-internal(!issue-font,@theme-white)}\n", ""]);

// exports
exports.locals = {
	"root": "ZGsu9NVWeyQEtYwQvp0Ca"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/campaign-status/CampaignStatus.scss
// module id = 886
// module chunks = 1